<template>
  <div>
    <div class="box" :value="confirmEvent">
      <BBtnSelectUpload
        class="button"
        btn-txt="选择上传视频"
        v-model="videodata"
      />
      <div class="video-box">
        <div v-show="display">
          <div class="inner-box">
            <video class="video" ref="videoPlayer" controls></video>
            <img
              v-if="deleteFlag"
              class="delete-img"
              src="@/assets/circle-delete.png"
              v-on:click="deleteVideo"
              alt=""
            />
            <Bvideo></Bvideo>
          </div>
          <BProgress v-if="videoFlag" v-model="progress" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BBtnSelectUpload from "../../components2/BBtnSelectUpload";
import BProgress from "../../components2/BProgress";
// import ObsClient from "../../../lib/obs";
import { upload } from "@/api/upload";
import Vue from "vue";

export default {
  name: "PopupContents",
  props: {
    confirmEvent: Boolean,
  },
  components: {
    BBtnSelectUpload,
    BProgress,
  },
  data() {
    return {
      returnData: "this is return data",
      videodata: null,
      display: false,
      progress: 0,
      deleteFlag: true,
      videoFlag: false,
      VideoDuration: 0,
      videoCheckArray: [],
    };
  },
  methods: {
    work() {
      this.$emit("ok", this.returnData);
    },
    deleteVideo() {
      this.$refs.videoPlayer.src = "";
      this.display = false;
      this.videoCheckArray = []
    },
    async doUpload() {
      var formData = new FormData();
      formData.append("file", this.videodata.files[0]);
      formData.append("aa", "bb");
      for (var key of formData.entries()) {
        console.log(key[0] + ", " + key[1]);
      }
      const data = await upload(formData, this.doUploadProgress);
      var param = {
        fileUrl: data[0],
        playTime: this.VideoDuration,
      };
      this.returnData = param;
      this.$refs.videoPlayer.src = data;
      this.$emit("input", false);
      this.work();
    },
    doUploadProgress(event) {
      this.progress = (event.loaded / this.videodata.files[0].size) * 100;
      if (this.progress > 100 || this.progress === 100) {
        // 暂停播放
        this.$refs.videoPlayer.pause();
        this.deleteFlag = false;
        this.videoFlag = false;
        Vue.prototype.$vsnackbar.show("上传成功");
      }
    },
  },
  watch: {
    videodata() {
      this.videoCheckArray = []
      this.display = true;
      var URL = window.URL || window.webkitURL;
      var fileURL = URL.createObjectURL(this.videodata.files[0]);
      this.videoCheckArray.push(this.videodata.files[0])
      this.$refs.videoPlayer.src = fileURL;
      // 获取视频时长
      let audioElement = new Audio(fileURL)
      const that = this
      audioElement.addEventListener("loadedmetadata",function () {
        var du = audioElement.duration
        that.VideoDuration = Math.floor(du)
      })
    },
    confirmEvent() {
      if (this.confirmEvent === true) {
        // 上传视频check
        var msg = this.comUtils.checkFilesUpload(this.videoCheckArray,'video',1)
        if(msg !== undefined){
            if (msg.snackbarText !== "") {
                Vue.prototype.$valertbar.show(msg.snackbarText);
                this.work();
            } else {
              this.doUpload();
              this.videoFlag = true;
            }
        }else{
           this.work();
        }

      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.button {
  align-self: flex-start;
}

.video-box {
  display: flex;
  justify-content: center;
  width: 700px;
  height: 300px;
  margin: 50px 0;
}

.inner-box {
  display: flex;
  position: relative;
}

.video {
  width: 448px;
  height: 273px;
  background: #000000;
}

.delete-img {
  position: relative;
  width: 23px;
  height: 23px;
  left: -12px;
  top: -12px;
}
</style>
